import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { mapUpdateCostCenterFromTransport, mapUpdateCostCenterToTransport } from '../mappers';
import type { LC_UpdateCostCenterOut, UpdateCostCenterRequest, UpdateCostCenterResult } from '../types';


export class CostCenterUpdateService {
  async update(
    costCenterId: number,
    request: UpdateCostCenterRequest,
  ): Promise<ApiResponse<UpdateCostCenterResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.COST_CENTER_BY_ID(costCenterId);
    const payload = mapUpdateCostCenterToTransport(request);
    const response = await apiClient.put<LC_UpdateCostCenterOut>(endpoint, payload);
    if (response.success && response.data) {
      return { ...response, data: mapUpdateCostCenterFromTransport(response.data) };
    }
    return { ...response, data: null };
  }
}

export const costCenterUpdate = new CostCenterUpdateService();
